import axios from 'axios';
import httpClient from './httpClient';
import {
  GetAllBrandListingsResponse,
  GetBrandListingByIdResponse,
  GetAllBrandListingsResult,
  BrandListing,
  BrandListingFilters,
} from '../types/brandlistingsmodel';

/**
 * Fetches approved listings for the brand panel via
 * GET /api/brand/get-approved-listing, with optional State/City/MediaType/
 * MinRent/MaxRent filters applied server-side.
 * Returns { total, listings } on success, throws an Error on failure.
 */
export const getAllBrandListings = async (
  filters: BrandListingFilters = {}
): Promise<GetAllBrandListingsResult> => {
  try {
    const { data } = await httpClient.get<GetAllBrandListingsResponse>(
      '/brand/get-approved-listing',
      {
        params: {
          State: filters.state || undefined,
          City: filters.city || undefined,
          MediaType: filters.mediaType || undefined,
          MinRent: filters.minRent ?? undefined,
          MaxRent: filters.maxRent ?? undefined,
        },
      }
    );
    if (!data.success || !data.result) {
      throw new Error(data.message || 'Failed to fetch listings.');
    }
    return data.result;
  } catch (err) {
    if (axios.isAxiosError<GetAllBrandListingsResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Failed to fetch listings.');
    }
    throw err;
  }
};

/**
 * Fetches a single approved listing's full details via
 * GET /api/brand/get-approved-listing/:id.
 * Returns the BrandListing on success, throws an Error on failure.
 */
export const getBrandListingById = async (id: string): Promise<BrandListing> => {
  try {
    const { data } = await httpClient.get<GetBrandListingByIdResponse>(
      `/api/brand/get-approved-listing/${id}`
    );
    if (!data.success || !data.result) {
      throw new Error(data.message || 'Failed to fetch listing details.');
    }
    return data.result.listing;
  } catch (err) {
    if (axios.isAxiosError<GetBrandListingByIdResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Failed to fetch listing details.');
    }
    throw err;
  }
};